import { render, staticRenderFns } from "./search.vue?vue&type=template&id=50c60300&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"
import style0 from "./search.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports